export const fetchLayoutsFromAPI = async () => {
  try {
    const response = await window.ZOHO.CRM.META.getLayouts({ Entity: "Deals" });
    console.log("Layouts:", response);
    return response.layouts.map(layout => ({ id: layout.id, name: layout.name }));
  } catch (error) {
    console.error("Error fetching layouts:", error);
    return [];
  }
};

export const fetchFormsFromAPI = async () => {
  try {
    const response = await window.ZOHO.CRM.META.getFields({ Entity: "Deals" });
    console.log("Deal fields for forms:", response);
    const formField = response.fields.find(field => field.api_name === "Form" || field.field_label === "Form");
    return formField ? formField.pick_list_values.map(value => ({
      id: value.id || value.actual_value || value.display_value,
      name: value.display_value || value.actual_value
    })) : [];
  } catch (error) {
    console.error("Error fetching forms:", error);
    return [];
  }
};

export const fetchPipelinesFromAPI = async (layoutId) => {
  try {
    console.log("Fetching pipelines...");
    const response = await window.ZOHO.CRM.CONNECTION.invoke('widgetconnection', {
      url: 'https://www.zohoapis.com/crm/v2.1/settings/pipeline',
      method: 'GET',
      parameters: { layout_id: layoutId },
      param_type: 1
    });

    const pipeline = response?.details?.statusMessage?.pipeline;

    if (pipeline) {
      return pipeline.map(p => ({
        id: p.id,
        name: p.display_value,
        stages: p.maps.map(stage => ({
          id: stage.id,
          name: stage.display_value
        }))
      }));
    } else {
      console.error("Unexpected response structure:", response);
      return [];
    }
  } catch (error) {
    console.error("Error fetching pipelines:", error);
    return [];
  }
};


export const getModuleFields = async (moduleName) => {
  try {
    const response = await window.ZOHO.CRM.META.getFields({ Entity: moduleName });
    console.log(`${moduleName} Fields:`, response);

    // Find the "Type" field and extract its picklist values
    const typeField = response.fields.find(field => field.field_label === "Type");
    const typePicklistValues = typeField ? typeField.pick_list_values.map(value => value.display_value) : [];
    console.log("Type Picklist Values:", typePicklistValues);

    return typePicklistValues;
  } catch (error) {
    console.error(`Error fetching fields for module ${moduleName}:`, error);
    return []; // Return an empty array in case of error
  }
};

export const executeCustomFunction = async (functionName, reqData) => {
  try {
    const response = await window.ZOHO.CRM.FUNCTIONS.execute(functionName, reqData);
    console.log("Custom Function Response:", response);
    return response;
  } catch (error) {
    console.error("Error executing custom function:", error);
    throw error;
  }
};

export const fetchRecord = async (moduleName, recordId) => {
  try {
    const response = await window.ZOHO.CRM.API.getRecord({ Entity: moduleName, RecordID: recordId });
    console.log(`${moduleName} Record:`, response);
    return response;
  } catch (error) {
    console.error(`Error fetching record for module ${moduleName}:`, error);
    throw error;
  }
};
